module.exports = __webpack_public_path__ + "static/media/Double Matting Vertical Text.5da58a39.png";